var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Arrays from "./arrays";
export { Arrays };
var _generalUpdater = makeUpdater();
export var updateIn = function (o) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return _generalUpdater(o, args[args.length - 1], args, 0, args.length - 2);
};
export var Prism;
(function (Prism) {
    function of(spec) {
        var func = function (o) {
            return spec.get(o);
        };
        var set = function (tOrV, v) {
            if (arguments.length === 1) {
                return function (t) { return spec.set(t, tOrV); };
            }
            else {
                return spec.set(tOrV, v);
            }
        };
        var update = function (tOrFn, f) {
            if (f === undefined) {
                return function (t) { return func.update(t, tOrFn); };
            }
            else {
                var t = tOrFn;
                var v = spec.get(t);
                if (v === undefined) {
                    return t;
                }
                else {
                    return spec.set(t, f(v));
                }
            }
        };
        var comp = function () {
            var prisms = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                prisms[_i] = arguments[_i];
            }
            return Prism.comp.apply(Prism, [func].concat(prisms));
        };
        func.get = spec.get;
        func.set = set;
        func.update = update;
        func.comp = comp;
        return func;
    }
    Prism.of = of;
    function comp() {
        var prisms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            prisms[_i] = arguments[_i];
        }
        var performComposedSet;
        return Prism.of({
            get: function (o) {
                return prisms.reduce(function (o, l) { return (o === undefined ? o : l.get(o)); }, o);
            },
            set: function (o, v) {
                if (performComposedSet === undefined) {
                    performComposedSet = makeComposedSetter();
                }
                return performComposedSet(o, v, prisms, 0);
            }
        });
    }
    Prism.comp = comp;
})(Prism || (Prism = {}));
export var Lens;
(function (Lens) {
    function from() {
        return new LensFactory();
    }
    Lens.from = from;
    function of(spec) {
        return Prism.of(spec);
    }
    Lens.of = of;
    function map(l, f) {
        return Lens.of({
            get: function (o) { return f.to(l.get(o)); },
            set: function (o, v) { return l.set(o, f.from(v)); }
        });
    }
    Lens.map = map;
    function comp() {
        var lenses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            lenses[_i] = arguments[_i];
        }
        return Prism.comp.apply(undefined, lenses);
    }
    Lens.comp = comp;
})(Lens || (Lens = {}));
function makeComposedSetter() {
    var performComposedSet = function (o, v, lenses, index) {
        if (index == lenses.length - 1) {
            return lenses[index].set(o, v);
        }
        else {
            var inner = lenses[index].get(o);
            if (inner) {
                return lenses[index].set(o, performComposedSet(inner, v, lenses, index + 1));
            }
            else {
                return o;
            }
        }
    };
    return performComposedSet;
}
function makeUpdater() {
    var performUpdate = function (o, v, keys, idx, last) {
        var copy = __assign({}, o);
        if (idx == last) {
            copy[keys[idx]] = v;
            return copy;
        }
        else {
            copy[keys[idx]] = performUpdate(o[keys[idx]], v, keys, idx + 1, last);
            return copy;
        }
    };
    return performUpdate;
}
var LensFactory = (function () {
    function LensFactory() {
    }
    LensFactory.prototype.prop = function () {
        var ks = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ks[_i] = arguments[_i];
        }
        var performUpdate;
        return Lens.of({
            get: function (o) {
                return ks.reduce(function (x, k) { return x[k]; }, o);
            },
            set: function (o, v) {
                if (performUpdate === undefined) {
                    performUpdate = makeUpdater();
                }
                return performUpdate(o, v, ks, 0, ks.length - 1);
            }
        });
    };
    return LensFactory;
}());
export { LensFactory };
//# sourceMappingURL=index.js.map